<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">Empty Page</strong>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            teste 9879

           <vue-speedometer :value="toggle ? 333 : 555"/>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import VueSpeedometer from 'vue-speedometer'

export default {
  components: {
    VueSpeedometer,

  },
  data: function () {
    return {
      toggle: false,
    }
  },
}
</script>
